import { connect } from 'react-redux';
import Header from '../components/Header';

function mapStateToProps( state ){
    return state
}


export default connect(mapStateToProps)(Header)
